import { combineReducers } from 'redux';
import {
  ADD_CHECKLIST_ITEM,
  DELETE_CHECKLIST_ITEM,
  TOGGLE_CHECKLIST_ITEM_MODAL,
  UPDATE_CHECKLIST_ITEM,
  UPDATE_CHECKLIST_ITEMS
} from '../actions/index';

const checklistItems = (state = [], action) => {
  const normalizedState = Array.isArray(state) ? state : [];
  switch (action.type) {
  case ADD_CHECKLIST_ITEM:
    return [...normalizedState, action.payload.data];
  case UPDATE_CHECKLIST_ITEM: {
    const updatedItem = action.payload.data;
    return normalizedState.map(item => item.id === updatedItem.id ? updatedItem : item);
  }
  case UPDATE_CHECKLIST_ITEMS: {
    const updatedItems = action.payload && Array.isArray(action.payload.data) ? action.payload.data : [];
    const updatedIds = updatedItems.map(item => item.id);
    const nonUpdatedItems = normalizedState.filter(item => !updatedIds.includes(item.id));
    return [...nonUpdatedItems, ...updatedItems];
  }
  case DELETE_CHECKLIST_ITEM:
    return normalizedState.filter(item => item.id !== action.payload);
  default:
    return normalizedState;
  }
};

const checklistItemModal = (state = false, action) => {
  switch (action.type) {
  case TOGGLE_CHECKLIST_ITEM_MODAL:
    return { ...state, ...action.payload };
  default:
    return state;
  }
};

const rootReducer = combineReducers({
  checklistItems,
  checklistItemModal,
  limitToUsers: state => state || [],
});

export default rootReducer;
